AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "Settings");

AoPS.Alcumus.Models.Settings = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var AlcMBase = AoPS.Alcumus.Models.Base;

	return AlcMBase.BaseModel.extend({
		defaults: {
			difficulty: 0,
			public_profile: 0,
			stats: 0,
			advance_master: 0,
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
		*/

		// The 'name' field of each entry here should match the names of the fields
		// in this model.
		settings_format: [
			{
				name: "difficulty",
				label: "Problem Difficulty",
				values: [
					{value: -1, label: "Easy"},
					{value: 0, label: "Normal"},
					{value: 1, label: "Hard"},
					{value: 2, label: "Insanely Hard"},
				],
				description:
					"The difficulty you select determines whether Alcumus " +
					"gives you problems that are easy for you, normal for you, hard for you, or insanely hard for you.",
			},
			{
				name: "public_profile",
				label: "Enable Public Profile",
				values: [
					{value: 0, label: "No"},
					{value: 1, label: "Yes"},
				],
				description:
					"Selecting “<strong>No</strong>” means that only you and your friends can see your Profile page. <br>" +
					"Selecting “<strong>Yes</strong>” means that anyone on Alcumus can see your Profile page.",
			},
			{
				name: "stats",
				label: "Include in Hall of Fame",
				values: [
					{value: 0, label: "No"},
					{value: 1, label: "Yes"},
				],
				description:
					"Selecting “<strong>No</strong>” means that you will not be included in the public Hall of Fame. <br>" +
					"Selecting “<strong>Yes</strong>” means that you will be included in the public Hall of Fame.",
			},
			{
				name: "advance_master",
				label: "Advance Only on Mastery",
				values: [
					{value: 0, label: "No"},
					{value: 1, label: "Yes"},
				],
				description:
					"This setting only takes effect when you are not doing assignments from a class. <br>" +
					"Selecting “<strong>No</strong>” means that Alcumus will advance your focus when you either pass or master your current focus topic. <br>" +
					"Selecting “<strong>Yes</strong>” means that Alcumus will only advance your focus when you master your current focus topic.",
			},
		],

		requestLoad: function (callback, context) {
			this.get("user").requestLoad(callback, context);
		},

		edit: function (new_settings, callback, context) {
			if (!this.get("user").get("is_me")) {
				return false;
			}

			// Track old settings so we can revert on an error
			var old_settings = _.clone(this.attributes);

			this.set(new_settings);

			var ajax_data = {user_id: this.get("user").id};
			_.each(new_settings, function (val, key) {
				ajax_data["settings_" + key] = val;
			});

			callback = LoadUtils.makeCallback(callback, context);
			AlcMBase.ajax.run(
				"edit_settings",
				ajax_data,
				_.bind(function (ok, data) {
					if (!ok) {
						this.set(old_settings);
					}
					callback(ok, data);
				}, this)
			);
			return true;
		},
	});
})();
